(function ($, jQuery) {
    //Cookies code

    var windowWidth = $(window).width();

    //$(".panel-body").on("click", ".remove-category",function ()


    $("body").on('click', ".cookie-config-button", function () {
        $(".eu-cookie-compliance-save-preferences-button").addClass("cookies-active");
        $(".pop-up-cookies").addClass("cookies-active");
        $("#eu-cookie-compliance-categories").addClass("cookies-active");
        $(".eu-cookie-compliance-category").addClass("cookies-active");
        $(".background-cover").addClass("cookies-active");
        $("body").addClass("body-lock");
        $(".eu-cookie-compliance-buttons").addClass("cookies-active");
        $(".eu-cookie-compliance-categories-buttons").addClass("cookies-active");
        $(".sliding-popup-bottom").addClass("cookie-popup-slide");

        if (windowWidth > 909) {
            $('.agree-button').animate({
                top: 282//moves to position
            }, 0);
        }
    });

    $('#sliding-popup').attr("aria-label", "Cookie popup");

    $("body").on('click', ".eu-cookie-compliance-category>div", function (e) {
        if (e.target !== this) {
            return;
        }


        if ($(this).parent().hasClass("eu-cookie-compliance-category-expanded")) {
            var height = $(this).parent().height();
            // var windowWidth = $(window).width();
            if (windowWidth > 909) {
                $('.pop-up-cookies').animate({
                    height: 300, //moves up
                    "margin-top": 0
                });
            }
            $('.agree-button').animate({
                top: "-=" + height //moves up
            });



            // if (windowWidth < 910) {
            $('.eu-cookie-compliance-save-preferences-button').animate({
                top: "-=" + height //moves up
            });
            // }
            $(this).parent().removeClass("eu-cookie-compliance-category-expanded")


        } else {
            if ($(".eu-cookie-compliance-category-expanded").length > 0) {
                var height = $(".eu-cookie-compliance-category-expanded").height();
                // console.log(height);

                $(".eu-cookie-compliance-category").removeClass("eu-cookie-compliance-category-expanded");
                $(this).parent().addClass("eu-cookie-compliance-category-expanded");
                var height2 = $(this).parent().height();
                // console.log(height2);

                var height3 = height - height2;
                // console.log(height3);
                var heightdiff = height2 / 2;
                // console.log(heightdiff);
                // var windowWidth = $(window).width();
                if (windowWidth > 909) {
                    $('.pop-up-cookies').animate({
                        height: "-=" + height3,
                        "margin-top": heightdiff //increases height or decreases depending on values
                    });
                }

                $('.agree-button').animate({
                    top: "-=" + height3 //moves down or up depending on values of height3
                });

                // if (windowWidth < 910) {
                $('.eu-cookie-compliance-save-preferences-button').animate({
                    top: "-=" + height3 //moves down or up depending on values of height3
                });
                // }

            } else {
                $(this).parent().addClass("eu-cookie-compliance-category-expanded");
                var height = $(".eu-cookie-compliance-category-expanded").height();
                var heightdiff = height / 2;
                // console.log(heightdiff);


                // var windowWidth = $(window).width();
                if (windowWidth > 909) {
                    $('.pop-up-cookies').animate({
                        height: "+=" + height,
                        "margin-top": heightdiff//increases height or decreases depending on values
                    });
                }

                $('.agree-button').animate({
                    top: "+=" + height //moves up
                });

                // if (windowWidth < 910) {
                $('.eu-cookie-compliance-save-preferences-button').animate({
                    top: "+=" + height //moves up
                });
                // }



            }
        }
    });

    $("body").on('click', ".eu-cookie-compliance-category label", function () {
        $(this).toggleClass("toggle-off");
        $(this).parent().toggleClass("category-disabled");
    });



    // $("body").on('click',".background-cover", function () {
    //     $(".eu-cookie-compliance-save-preferences-button").removeClass("cookies-active");
    //     $(".pop-up-cookies").removeClass("cookies-active");
    //     $("#eu-cookie-compliance-categories").removeClass("cookies-active");
    //     $(".eu-cookie-compliance-category").removeClass("cookies-active");
    //     $(".eu-cookie-compliance-category").removeClass("eu-cookie-compliance-category-expanded");
    //     $(".background-cover").removeClass("cookies-active");
    //     $("body").removeClass("body-lock");
    //     $(".eu-cookie-compliance-buttons").removeClass("cookies-active");
    //     $(".eu-cookie-compliance-categories-buttons").removeClass("cookies-active");
    //     // var windowWidth = $(window).width();
    //     if (windowWidth > 909) {
    //         $('.agree-button').animate({
    //             top: 75
    //         }, 0);
    //     }
    // });

    $("body").on('click', ".cookies-reject-button", function () {
        $('.eu-cookie-compliance-category input').slice(1).prop("checked", false);
        $('.eu-cookie-compliance-save-preferences-button').click();
    })

    //END OF COOKIES

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    animtimes = 0;
    window.addEventListener('scroll', function () {
        var element = document.querySelector('.paragraph--type--icon-and-text .field--name-field-picture img');
        var position = element.getBoundingClientRect();

        // checking whether fully visible
        if (position.top >= 0 && position.bottom <= window.innerHeight) {
            if (animtimes < 1) {
                element.classList.toggle('remove-padding');
                // element.animate({ padding: 15 }, 250);
                animtimes = 1;
            }

        } else {
            element.classList.remove('remove-padding');
            animtimes = 0;
        }
    });


    var labelID;

    $('label').click(function () {
        labelID = $(this).attr('for');
        $('#' + labelID).trigger('click');
    });

    $("#block-website-botaodomenudoheader .hamb-menu").on("click", function () {
        $("#block-website-menumain").toggleClass("visible");
        $(this).toggleClass("menu-open");
        $("#block-search").toggleClass("visible");
        $("body").toggleClass("body-lock");
    });

    $("#block-website-botaodomenudoheader .hamb-menu").keypress(function (event) {
        if (event.which == 13) {
            $("#block-website-menumain").toggleClass("visible");
            $(this).toggleClass("menu-open");
            $("#block-search").toggleClass("visible");
            $("body").toggleClass("body-lock");
        }
    });

    $("#block-arrow-to-top .up-button").on("click", function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    })

    $("#block-arrow-to-top .up-button").keypress(function (event) {
        if (event.which == 13) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    });

    $("#block-website-menumain .menu-item--expanded i").on("click", function () {
        if ($(this).parent().parent().hasClass("opened")) {
            $(this).parent().parent().toggleClass("opened");
        } else {
            $(".menu-item").removeClass("opened");
            $(this).parent().parent().toggleClass("opened");
        }

        

        $(".menu-item--expanded>ul>li>a").attr("tabindex", -1);

        $(".opened>ul>li>a").attr('tabindex', 0);

        
        return false;
    });

    $("#block-website-menumain .menu-item--expanded .link-text").on("click", function () {
        if ($(this).parent().parent().hasClass("opened")) {
            $(this).parent().parent().toggleClass("opened");
            
        } else {
            $(".menu-item").removeClass("opened");
            $(this).parent().parent().toggleClass("opened");
           
        }

        $(".menu-item--expanded>ul>li>a").attr("tabindex", -1);

        $(".opened>ul>li>a").attr('tabindex', 0);


        return false;
    });

    $(".search-button i").on("click", function () {
        $("#block-search-form-full").toggleClass("visible");
        $(this).toggleClass("search-open");
        $("body").toggleClass("body-lock");

    });

    $(".search-button i").keypress(function (event) {
        if (event.which == 13) {
            $("#block-search-form-full").toggleClass("visible");
            $(this).toggleClass("search-open");
            $("body").toggleClass("body-lock");
        }
    });

   

    $("#block-website-menumain .menu-item--expanded button").keypress(function (e) {

        // alert("button got pressed on menu item");
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            if ($(this).parent().hasClass("opened")) {
                $(this).parent().toggleClass("opened");
            } else {
                $(".menu-item").removeClass("opened");
                $(this).parent().toggleClass("opened");
            }

        }

        $(".menu-item--expanded>ul>li>a").attr("tabindex", -1);

        $(".opened>ul>li>a").attr('tabindex', 0);
        return false;
    });

    // $(window).load(function () {
    //     var i = setInterval(function () {
    //         if ($('nav').length) {
    //             clearInterval(i);
    //         }
    //     }, 100);
    // });

    $(document).on('keydown', function (event) {
        var focus = $(':focus');

        if (event.key == "Escape") {
            if ($(".hamb-menu").hasClass("menu-open")) {
                $("#block-website-menumain").removeClass("visible");
                $(".hamb-menu").removeClass("menu-open");
                $("#block-search").removeClass("visible");
                $("body").removeClass("body-lock");
            }
        }

        // if (event.which == 13) {
        //     if(focus.hasClass("hamb-menu")) {
        //         $("#block-website-menumain").toggleClass("visible");
        //         $(this).toggleClass("menu-open");
        //         $("#block-search").toggleClass("visible");
        //         $("body").toggleClass("body-lock");
        //     }
        // }
    });


    $(document).ready(function () {
        $(".form-search").attr("placeholder", "Pesquisar");

        $("#to-main-content").detach().prependTo('header');

        $("#sliding-popup").attr("aria-label", "Cookie popup");

        // alert("removing attribute");

        // $("#block-website-menumain>.menu>.menu-item>.menu>li").attr('tabindex', -1);

        $("#block-website-menumain button").attr('tabindex', 0);

        $("#block-website-menumain>.menu>.menu-item>a").attr('tabindex', 0);

        var hasmenu = $('#block-menuprincipal').length;

        $("nav").removeAttr("role");

        if (hasmenu == 0 && window.location.href.indexOf("/visualizadores") == -1) {
            $("#block-views-block-menu-banner-inner-pages-block-1").addClass("no-menu");
        }

        $(".eu-cookie-compliance-banner .cookie-config-button").attr("tabindex", 0);
        $(".eu-cookie-compliance-banner .cookies-reject-button").attr("tabindex", 0);
        $(".eu-cookie-compliance-banner .agree-button").attr("tabindex", 0);





        // $("#block-website-menumain .menu-item--expanded").addClass("opened");

        var otxt = $(".breadcrumb")
            .clone()
            .children()
            .remove()
            .end()
            .text();

        var tstr = $.trim(otxt);

        if (tstr === "") {
            return false;
        }

        var txt2 = $("<a></a>").text(tstr);



        $(".breadcrumb a:nth-child(2)").after(txt2);

        $('.breadcrumb').contents().filter(function () {
            return this.nodeType === 3;
        }).remove();
    });



}(jQuery));